/*
 * Converts a number to a currency string
 */
Number.prototype.currency = function () {
    if (this < 0) {
        return "-$" + Math.abs(this).format(2);
    }

    return "$" + this.format(2);
};